import './filmography.css'
import Fade from 'react-reveal/Fade';

export default function Filmography(){
    return(
        <div id="filmography">
            <div id='first-container' className='position-relative mt-5'>
                <div id='satu' className='position-absolute top-50 start-50 translate-middle justify-content-center row row-cols-xl-3 row-cols-2'>
                    <img className='p-0' src="./Project/11.png" alt="" />
                    <img className='p-0' src="./Project/12.jpeg" alt="" />
                    <img className='p-0' src="./Project/9.png" alt="" />
                    <img className='p-0' src="./Project/10.png" alt="" />
                    <img className='p-0' src="./Project/4.jpeg" alt="" />
                    <img className='p-0' src="./Project/1.png" alt="" />
                </div>
                <div id='dua' className='d-flex flex-column align-item-center w-100'>
                    <h1 className='text-oren'>Film Terbaru <br/>Saya</h1>
                    <h3 className='d-flex flex-column'>
                        <p>"Ephemera" <span>|</span> 2022 - Helies Pictures</p>
                        <p>"Tehman Ads" <span>|</span> 2022 - Acierto Visuals</p>
                        <p>"Cahaya Cinta Perlahan Menyilaukan" <span>|</span> 2022 - Film UMN</p>
                        <p>"Surro" <span>|</span> 2022 - Helies Pictures</p>
                        <p>"What Now?" <span>|</span> 2021 - Swakarya Production</p>
                        <p>"Scared to be Lonely" <span>|</span> 2021 - Nuvo Films</p>
                        <p>"Di Balik Jiwa yang Kuat" <span>|</span> 2021 - OnTheDot Production</p>
                    </h3>
                </div>
            </div>

            <Fade>
            <div id='fill'>
                <img src="./Project/8.png" alt="" />
                <div id='text'>
                    <h2>"Ephemera" <span>|</span> 2022 - Helies Pictures</h2>
                    <h3>Di dalam proses pembuatan film "Ephemera" saya mendapatkan 
                        posisi sebagai Production Designer. Tugas saya adalah untuk 
                        merealisasikan visual Director ke dalam sebuah set yang didesain 
                        sedemikian rupa. Proses pembuatan film dari tahap pra produksi 
                        hingga pasca produksi memakan waktu kurang lebih 5 bulan yang 
                        dimulai dari awal bulan Agustus hingga Desember.</h3>
                </div>
                <h4>"Ephemera" - 2022</h4>
            </div>
            </Fade>

            <Fade>
            <div id='fill'>
                <img src="./Project/11.png" alt="" />
                <div id='text'>
                    <h2>"Tehman Ads" <span>|</span> 2022 - Acierto Visuals</h2>
                    <h3>Di dalam proses pembuatan iklan "Tehman" saya bertugas sebagai 
                        Art Assistant. Di posisi ini saya membantu Art Director merealisasikan 
                        visualnya yang sudah didiskusikan bersama Director. Di dalam 
                        proses pembuatannya, saya hanya mengikuti di bagian pra produksi 
                        dan pada hari produksi saja.</h3>
                </div>
                <h4>"Tehman Ads" - 2022</h4>
            </div>
            </Fade>

            <Fade>
            <div id='fill'>
                <img src="./Project/12.jpeg" alt="" />
                <div id='text-khusus'>
                    <h2>"Cahaya Cinta Perlahan Menyilaukan" <span>|</span> 2022 - Film UMN</h2>
                    <h3>Di dalam proses pembuatan film "CCPM" saya mendapatkan 
                        posisi sebagai Art Assistant. Tugas saya adalah untuk membantu 
                        merealisasikan visual Art Director ke dalam sebuah set 
                        yang didesain sedemikian rupa. Proses yang saya ikuti dalam 
                        pembuatan film ini hanya pada pra produksi hingga masa produksi.</h3>
                </div>
                <h4>"Cahaya Cinta Perlahan Menyilaukan" - 2022</h4>
            </div>
            </Fade>


            <Fade>
            <div id='fill'>
              <img src="./Project/1.png" alt="" />
              <div id='text'>
                    <h2>"Surro" <span>|</span> 2022 - Helies Pictures</h2>
                    <h3>Di dalam proses pembuatan film "Surro" saya mendapatkan 
                        posisi sebagai Production Designer. Tugas saya adalah untuk 
                        merealisasikan visual Director ke dalam sebuah set yang 
                        didesain sedemikian rupa. Saya mengikuti proses pembuatan 
                        film dari awal (pra produksi) hingga akhir (pasca produksi) 
                        yang memakan waktu kurang lebih 5 bulan.</h3>
                </div>
                <h4>"Surro" - 2022</h4>
            </div>
            </Fade>

            <Fade>
            <div id='fill'>
                <img src="./Project/9.png" alt="" />
                <div id='text'>
                    <h2>"What Now?" <span>|</span> 2021 - Swakarya Production</h2>
                    <h3>Di dalam proses pembuatan film "What Now" saya mendapatkan 
                        posisi sebagai Production Designer. Tugas saya adalah untuk 
                        merealisasikan visual Director ke dalam sebuah set yang 
                        didesain sedemikian rupa. Proses pembuatan film dari tahap 
                        pra produksi hingga pasca produksi memakan waktu kurang lebih 3 bulan.</h3>
                </div>
                <h4>"What Now?" - 2021</h4>
            </div>
            </Fade>

            <Fade>
            <div id='fill'>
                <img src="./Project/4.jpeg" alt="" />
                <div id='text'>
                    <h2>"Scared to be Lonely" <span>|</span> 2021 - Nuvo Films</h2>
                    <h3>Di dalam proses pembuatan film "Scared to be Lonely" saya 
                        mendapatkan posisi sebagai Art Director. Tugas saya adalah 
                        untuk merealisasikan visual Director ke dalam sebuah set yang 
                        didesain sedemikian rupa. Proses pembuatan film yang saya 
                        ikuti adalah dari tahap pra produksi hingga produksi.</h3>
                </div>
                <h4>"Scared to be Lonely" - 2021</h4>
            </div>
            </Fade>

            <Fade>
            <div id='fill'>
                <img src="./Project/10.png" alt="" />
                <div id='text'>
                    <h2>"Di Balik Jiwa yang Kuat" <span>|</span> 2021 - OnTheDot Production</h2>
                    <h3>Di dalam proses pembuatan film "DBJK" saya mendapatkan 
                        posisi sebagai Art Director dan Director. Tugas saya adalah 
                        untuk merealisasikan visual Director ke dalam sebuah set 
                        yang didesain sedemikian rupa. Proses pembuatan film yang 
                        saya ikuti adalah dari tahap pra produksi hingga pasca produksi.</h3>
                </div>
                <h4>"Di Balik Jiwa Yang Kuat" - 2021</h4>
            </div>
            </Fade>
            
        </div>
    )
}